/* TypeScript file generated from Env.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as EnvJS from './Env.res.js';

export const sentryDsn: () => (undefined | string) = EnvJS.sentryDsn as any;

export const intercomAppID: () => string = EnvJS.intercomAppID as any;

export const postHogAppKey: () => string = EnvJS.postHogAppKey as any;

export const context: () => "staging" | "dev" | "test" | "production" = EnvJS.context as any;
